import {ICONS} from '@/constants/icons';

export default {
  updatedAtLabel: 'Mis à jour:',
  breadcrumbs: {
    home: 'Accueil',
  },
  hero: {
    badges: [
      {
        iconName: 'badgeTrustUs',
        description: 'Pourquoi vous pouvez nous faire confiance',
        details: {
          text: `<h2>Pourquoi vous pouvez nous faire confiance</h2><p>Les articles publiés sur Natu.Care sont rédigés à partir de recherches scientifiques, de données provenant de sites web gouvernementaux et d'autres sources fiables. Les textes sont rédigés en collaboration avec des médecins, des nutritionnistes et d'autres experts en santé et beauté. Les articles sont révisés avant leur publication et lors de mises à jour importantes.</p>.`,
          footerText: '<p>En savoir plus sur notre <a href="/fr/a-propos/processus-editorial">processus éditorial</a></p>.'
        }
      },
      {
        iconName: 'badgeAdDisclosure',
        description: 'Informations sur les publicités',
        details: {
          text: `<h2>Informations sur les publicités</h2><p>Le contenu de Natu.Care peut contenir des liens vers des produits dont la vente peut nous rapporter une commission. Lors de la création de contenu, nous respectons des normes éditoriales élevées et veillons à rester objectifs concernant les produits présentés. La présence de liens d'affiliation n'est pas dictée par nos partenaires, et nous sélectionnons les produits que nous évaluons de manière totalement indépendante.</p>.`,
          footerText: '<p>En savoir plus sur notre <a href="/fr/a-propos/processus-editorial">processus éditorial</a></p>.'
        }
      }
    ],
    tooltip: {
      labelVerified: 'Vérifié par un expert',
      footerText: '<p>En savoir plus sur notre <a href="/fr/a-propos/processus-editorial">processus éditorial</a></p>.'
    }
  },

  mediabar: {
    heading: 'Médias à propos de nous :',
    href: '/fr/a-propos',
    title: 'Médias à notre sujet :',
    items: [
      {
        icon: ICONS['vogue'],
        href: 'https://kobieta.wp.pl/toner-do-wlosow-jak-nakladac-6861428991200064a'
      },
      {
        icon: ICONS['wpKobieta'],
        href: 'https://zdrowietvn.pl/a/poznaj-zrodla-kolagenu-i-badz-piekna'
      },
      {
        icon: ICONS['medonet'],
        href: 'https://porady.interia.pl/artykul-sponsorowany/news-poznaj-dzialanie-tonera-do-wlosow,nId,6525474'
      },
      {
        icon: ICONS['zdrowieTvn'],
        href: 'https://zwierciadlo.pl/material-partnera/532112,1,toner-do-wlosow--jak-nakladac.read'
      },
      {
        icon: ICONS['interiaPorady'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      },
      {
        icon: ICONS['zwierciadlo'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      },
      {
        icon: ICONS['uPacjenta'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      }   
    ]
  },

  cta: {
    heading: 'Prenez soin de votre santé physique',
    description: `Essayez les compléments alimentaires de haute qualité de Natu.Care.`,
    button: {label: 'See products', href: 'https://natu.shop/collections'},
    picture: {alt: 'Jeunes femmes belles et ayant une belle peau'}
  },

  authorship: {
    heading: 'Éditoriaux',
    link: {
      label: `Rencontrez l'équipe`,
      href: '/fr/a-propos-us/equipe-editoriale'
    }
  },

  similarArticles: {
    headingBlogList: 'Articles',
    headingBlogPost: 'Articles similaires'
  }  
};
